import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getBeefFootprintByYear, getBeefFootprintByYearAdmin } from "services";

import { getActiveToken, getEnvironment, shouldRetryQueryError, useGetCarbonProgramByFarmId, useUserContext } from "utils";

import { FOOTPRINTING_BEEF } from "consts";

export const useGetFootprintingBeefFootprint = (farmId?: string, year?: number, { enabled = true } = {}) => {
  const isAdmin = getEnvironment().admin;
  const { user } = useUserContext();
  const queryClient = useQueryClient();
  const { data: carbonProgram } = useGetCarbonProgramByFarmId(farmId);
  const token = getActiveToken();

  const enableQuery = isAdmin
    ? (enabled && !!farmId && !!year) ?? false
    : (enabled && !!farmId && !!year && !!user && carbonProgram?.platformFeatures?.footprinting?.enabled && !!token) ?? false;

  return useQuery(
    {
      queryKey: [FOOTPRINTING_BEEF, farmId, year, isAdmin],
      queryFn: async () => (isAdmin ? getBeefFootprintByYearAdmin(farmId ?? "", year ?? 0) : getBeefFootprintByYear(farmId ?? "", year ?? 0)),
      enabled: enableQuery,
      staleTime: 0,
      gcTime: 60000,
      retry: shouldRetryQueryError(),
    },
    queryClient
  );
};
